module.exports = __webpack_public_path__ + "img/color.37ccc2d5.png";